//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getfetchImgMx from '@/common/mixin/getfetchImg.js'
import GAwesomeSwiper from '@/common/components/g-awesome-swiper/'
import { goSlotGame, goGame } from '@/common/utils/common.js';
export default{
  mixins: [getfetchImgMx],
  props: {
    imgCode: {
      type: String,
      required: true
    },
    pagination: {
      type: Boolean,
      default: true
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    navigaiton: {
      type: Boolean,
      default: false
    },
    navigaitonWhite: {
      type: Boolean,
      default: false
    },
  },
  components: { GAwesomeSwiper },
  data() {
    return {
      imglist: []
    }
  },
  created() {
    this._getfetchImg(this.imgCode)
  },

  methods: {
    implementationFetched([data, res], imgCode) {
      this.$nextTick(() => {
        this.imglist = data
      })
    },
    handleClickMore(v) {
      if (!this.imglist[v]) return
      const links = this.imglist[v].imgClickLink
      if (links.indexOf('http') !== -1) {
        const deviceId = this.$Cookies.get('deviceId') ? this.$Cookies.get('deviceId') : '';
        const lang = this.$Cookies.get('lang') ? this.$Cookies.get('lang') : '';
        const UUID = this.$store.state.UUID;
        const linkType = 1;
        if (links.indexOf('?') !== -1) {
          window.open(`${links}&linkType=${linkType}&UUID=${UUID}&deviceId=${deviceId}&lang=${lang}`, '_blank')
        } else {
          window.open(`${links}?linkType=${linkType}&UUID=${UUID}&deviceId=${deviceId}&lang=${lang}`, '_blank')
        }
      } else if (links.split('?')[0] === '/launchGame' || links.split('?')[0] === '/launchGameType' || links.split('?')[0] === '/launchGamePlatform'){
        if (this.$store.state.showLogin) this.$store.commit('SET_LOGIN_HIDE')
        if (this.$store.state.showRegister) this.$store.commit('SET_REGISTER', false)
        // this.$router.replace({ path: links.replace('#', '') })
        const strParams = links.split('?')[1];
        const arrParams = strParams.split('&');
        let objParams = {}
        for (let i = 0; i <arrParams.length; i++) {
          const arrKey = arrParams[i].split('=');
          objParams[arrKey[0]] = arrKey[1]
          if (arrKey[0] === 'platformKey') {
            objParams.fullName = arrKey[1]
          }
        }
        // goSlotGame方法  &gameCode=${item.gameId}
        objParams.gameId = objParams.gameCode
        const { gameType, platformKey, platformCode, popularType } = objParams
        if (gameType === '4' && platformCode === 'GT') { // 表示跳到彩票
          const type = (platformKey && platformKey.indexOf('GT_LOTTERY_') > -1) ? platformKey.replace('GT_LOTTERY_', '') : '3'
          this.$router.push({ path: '/bet', query: { type } })
          return
        }

        if (links.split('?')[0] === '/launchGame') {  // 进入具体游戏
          if (gameType === '1') {
            goSlotGame(objParams, this.$store.state.isLogin, this.$store.state.UUID)
          } else if (gameType !== '1') {
            goGame(objParams, this.$store.state.isLogin, this.$store.state.UUID)
          }
          return
        } else if (links.split('?')[0] === '/launchGameType' || links.split('?')[0] === '/launchGamePlatform'){
          let path = ''
          if (gameType === '1' && this.$route.path !== '/gamelobby/egame') {
            path = '/gamelobby/egame'
          }
          if (gameType === '2' && this.$route.path !== '/gamelobby/live') {
            path = '/gamelobby/live'
          }
          if (gameType === '3' && this.$route.path !== '/gamelobby/sports') {
            path = '/gamelobby/sports'
          }
          if (gameType === '4' && this.$route.path !== '/gamelobby/lottery') {
            path = '/gamelobby/lottery'
          }
          if (gameType === '5' && this.$route.path !== '/gamelobby/fish') {
            path = '/gamelobby/fish'
          }
          if (gameType === '6' && this.$route.path !== '/gamelobby/chess') {
            path = '/gamelobby/chess'
          }
          if (links.split('?')[0] === '/launchGamePlatform' && platformCode) {
            setTimeout(()=>{
              this.$store.commit('setEventPlatFormCode', platformCode)
            }, 1200)
          }
          if (path !== '') {
            setTimeout(()=>{
              this.$store.commit('setEventBanner', Number(gameType))
            })
            this.$router.push({
              path
            })
          }
        }

      } else {
        this.$router.push({path: links})
      }
    },
    handleClick(v) {
      if (!v) return
      const links = v.imgClickLink
      if (links === '') return
      if (links.indexOf('http') !== -1) {
        const deviceId = this.$Cookies.get('deviceId') ? this.$Cookies.get('deviceId') : '';
        const lang = this.$Cookies.get('lang') ? this.$Cookies.get('lang') : '';
        const UUID = this.$store.state.UUID;
        const linkType = 1;
        if (links.indexOf('?') !== -1) {
          window.open(`${links}&linkType=${linkType}&UUID=${UUID}&deviceId=${deviceId}&lang=${lang}`, '_blank')
        } else {
          window.open(`${links}?linkType=${linkType}&UUID=${UUID}&deviceId=${deviceId}&lang=${lang}`, '_blank')
        }
      } else if (links.split('?')[0] === '/launchGame' || links.split('?')[0] === '/launchGameType' || links.split('?')[0] === '/launchGamePlatform'){
        if (this.$store.state.showLogin) this.$store.commit('SET_LOGIN_HIDE')
        if (this.$store.state.showRegister) this.$store.commit('SET_REGISTER', false)
        // this.$router.replace({ path: links.replace('#', '') })
        const strParams = links.split('?')[1];
        const arrParams = strParams.split('&');
        let objParams = {}
        for (let i = 0; i <arrParams.length; i++) {
          const arrKey = arrParams[i].split('=');
          objParams[arrKey[0]] = arrKey[1]
          if (arrKey[0] === 'platformKey') {
            objParams.fullName = arrKey[1]
          }
        }
        // goSlotGame方法  &gameCode=${item.gameId}
        objParams.gameId = objParams.gameCode
        const { gameType, platformKey, platformCode, popularType } = objParams
        if (gameType === '4' && platformCode === 'GT') { // 表示跳到彩票
          const type = (platformKey && platformKey.indexOf('GT_LOTTERY_') > -1) ? platformKey.replace('GT_LOTTERY_', '') : '3'
          this.$router.push({ path: '/bet', query: { type } })
          return
        }

        if (links.split('?')[0] === '/launchGame') {  // 进入具体游戏
          if (gameType === '1') {
            goSlotGame(objParams, this.$store.state.isLogin, this.$store.state.UUID)
          } else if (gameType !== '1') {
            goGame(objParams, this.$store.state.isLogin, this.$store.state.UUID)
          }
          return
        } else if (links.split('?')[0] === '/launchGameType' || links.split('?')[0] === '/launchGamePlatform'){
          let path = ''
          if (gameType === '1' && this.$route.path !== '/gamelobby/egame') {
            path = '/gamelobby/egame'
          }
          if (gameType === '2' && this.$route.path !== '/gamelobby/live') {
            path = '/gamelobby/live'
          }
          if (gameType === '3' && this.$route.path !== '/gamelobby/sports') {
            path = '/gamelobby/sports'
          }
          if (gameType === '4' && this.$route.path !== '/gamelobby/lottery') {
            path = '/gamelobby/lottery'
          }
          if (gameType === '5' && this.$route.path !== '/gamelobby/fish') {
            path = '/gamelobby/fish'
          }
          if (gameType === '6' && this.$route.path !== '/gamelobby/chess') {
            path = '/gamelobby/chess'
          }
          if (links.split('?')[0] === '/launchGamePlatform' && platformCode) {
            setTimeout(()=>{
              this.$store.commit('setEventPlatFormCode', platformCode)
            }, 1200)
          }
          if (path !== '') {
            setTimeout(()=>{
              this.$store.commit('setEventBanner', Number(gameType))
            })
            this.$router.push({
              path
            })
          }
        }

      } else {
        this.$router.push({path: links})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/links-banner/index.vue